import { css } from 'lit'
import { csSpacing } from '@cloudsuite/mosaic-shared/styles/spacing.style.js'
import { csBorder } from '@cloudsuite/mosaic-shared/styles/globals.style.js'
import { csColorBackground, csColorBorder } from '@cloudsuite/mosaic-shared/styles/colors.style.js'

export const rmaProductRow = css`
  .rma-product-row {
    --cse-accordion-default-header-background-color: ${csColorBackground.primary};
    --cse-accordion-default-content-background-color: ${csColorBackground.primary};
    --cse-accordion-default-content-padding-y: 0;
    border: ${csBorder.width} solid ${csColorBorder.light};
    border-radius: ${csBorder.radiusMinimal};
  }

  .rma-product-row__heading {
    display: flex;
    flex-direction: column;
    gap: ${csSpacing.spacing06};
    width: 100%;
  }

  .rma-product-row__header {
    display: flex;
    align-items: flex-start;
    gap: ${csSpacing.spacing06};
    width: 100%;
  }

  .rma-product-row__info {
    display: flex;
    flex: 1;
    flex-direction: column;
    gap: ${csSpacing.spacing05};
    min-width: 0;
  }

  .rma-product-row__meta-label {
    font-weight: 700;
  }

  .rma-product-row__delete {
    margin-left: auto;
    background-color: ${csColorBackground.secondary};
    border-radius: ${csBorder.radiusFull};
  }

  .rma-product-row__image {
    width: 75px;
    height: 56px;
    object-fit: contain;
  }

  .rma-product-row__shipment {
    display: flex;
    flex-wrap: wrap;
    align-items: center;
    justify-content: space-between;
    column-gap: ${csSpacing.spacing06};
    row-gap: ${csSpacing.spacing08};
    width: 100%;
  }

  .rma-product-row__shipment-column {
    min-width: 160px;
    --cs-font-caption-s-text-transform: uppercase;
  }
`
